import { HomeContainer } from "@/features/app/containers/home-container";
import { beforeOrgMemberGuard } from "@/features/auth/guards";
import { createFileRoute } from "@tanstack/react-router";

// Layout route for all /app/* pages — provides auth guard + AppView sidebar shell.
export const Route = createFileRoute("/app")({
  beforeLoad: beforeOrgMemberGuard,
  component: HomeContainer,
});
